

export const ShopingItemsSection=()=>{
    
    
    return(
        <div className="shoping-items-section">
            <div className="shoping-items-section_row">
                <div className="shoping-items-section_el-1 shoping-items-section_el">
                    <img src={require('../../../../static/l1.jpg')}/>
                    <div className='shoping-item-overlay'></div>
                    <div className='shoping-item-overlay-logo'>
                        <img src={require('../../../../static/white-bike-icon.png')}/>
                    </div>
                </div>
                <div className="shoping-items-section_el-2 shoping-items-section_el">
                    <img src={require('../../../../static/l2.jpg')}/>
                    <div className='shoping-item-overlay'></div>
                    <div className='shoping-item-overlay-logo'>
                        <img src={require('../../../../static/white-bike-icon.png')}/>
                    </div>
                </div>
                <div className="shoping-items-section_el-3 shoping-items-section_el">
                    <img src={require('../../../../static/l3.jpg')}/>
                    <div className='shoping-item-overlay'></div>
                    <div className='shoping-item-overlay-logo'>
                        <img src={require('../../../../static/white-bike-icon.png')}/>
                    </div>
                </div>
                <div className="shoping-items-section_el-4 shoping-items-section_el">
                    <img src={require('../../../../static/l4.jpg')}/>
                    <div className='shoping-item-overlay'></div>
                    <div className='shoping-item-overlay-logo'>
                        <img src={require('../../../../static/white-bike-icon.png')}/>
                    </div>
                </div>
                <div className="shoping-items-section_el-5 shoping-items-section_el">
                    <img src={require('../../../../static/l5.jpg')}/>
                    <div className='shoping-item-overlay'></div>
                    <div className='shoping-item-overlay-logo'>
                        <img src={require('../../../../static/white-bike-icon.png')}/>
                    </div>   
                </div>
                <div className="shoping-items-section_el-6 shoping-items-section_el">
                    <img src={require('../../../../static/l6.jpg')}/>
                    <div className='shoping-item-overlay'></div>
                    <div className='shoping-item-overlay-logo'>
                        <img src={require('../../../../static/white-bike-icon.png')}/>
                    </div>
                </div>
                <div className="shoping-items-section_el-7 shoping-items-section_el">
                    <img src={require('../../../../static/l7.jpg')}/>
                    <div className='shoping-item-overlay'></div>
                    <div className='shoping-item-overlay-logo'>
                        <img src={require('../../../../static/white-bike-icon.png')}/>
                    </div>
                </div>
                <div className="shoping-items-section_el-8 shoping-items-section_el">
                    <img src={require('../../../../static/l8.jpg')}/>
                    <div className='shoping-item-overlay'></div>
                    <div className='shoping-item-overlay-logo'>
                        <img src={require('../../../../static/white-bike-icon.png')}/>
                    </div>
                </div>
            </div>
            <div className='shoping-items-section_link'>
                <a><p>DISCOVER THE SHOP</p></a>
            </div>
        </div>
    )
}